// スマホ下部固定の画面切替（リスト/マップ/ヒートマップ）の表示制御。
// インラインの view-toggle をスクロールで通り過ぎたら is-visible を付与する。
// sticky_cta.js と同じ scrollY 閾値方式。
(function () {
  'use strict';
  if (typeof document === 'undefined') return;
  if (window._viewToggleStickyInit) return;
  window._viewToggleStickyInit = true;

  var SCROLL_THRESHOLD = 320;

  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.querySelector('[data-view-toggle-sticky]');
    if (!bar) return;
    document.body.classList.add('has-view-toggle-sticky');
    function onScroll() {
      if (window.scrollY > SCROLL_THRESHOLD) {
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();
